class CountrySelector {
    constructor() {
        this.cookieName = 'user_region_preference';
        this.cookieExpireDays = 365;

        // Konfigurasi 5 region. "currency" dipakai untuk CurrencyConverter (display),
        // "shopifyCountry" dipakai untuk POST ke /localization (market/bahasa/shipping context Shopify).
        // PENTING: shopifyCountry harus terdaftar di Shopify Admin > Settings > Markets.
       this.regions = {
                ID: {
                    name: 'Indonesia',
                    flag: '🇮🇩',
                    currency: 'IDR',
                    shopifyCountry: 'ID',
                },
                ASIA: {
                    name: 'Asia',
                    flag: '🌏',
                    currency: 'IDR',
                    shopifyCountry: 'SG', 
                },
                EU: {
                    name: 'Europe & UK',
                    flag: '🇪🇺',
                    currency: 'EUR',
                    shopifyCountry: 'NL', 
                },
                NA: {
                    name: 'USA & Canada',
                    flag: '🇺🇸',
                    currency: 'USD',
                    shopifyCountry: 'US',
                },
                ROW: {
                    name: 'Australia',
                    flag: '🇦🇺',
                    currency: 'AUD',
                    shopifyCountry: 'AU', 
                },
            };

        this._listenersAttached = false;
        this._selecting = false;
        this._onEsc = null;

        this.init();
    }

    init() {
        const savedRegion = this.getCookie(this.cookieName);

        if (!savedRegion || !this.regions[savedRegion]) {
            this.createPopup();
        } else {
            // Returning user: cukup terapkan atribut ringan, TIDAK perlu
            // POST ulang ke /localization atau reload (sudah tersinkron dari kunjungan sebelumnya).
            this.applyRegionFeaturesQuiet(savedRegion);
        }
    }

    // --- Cookie helpers ---
    setCookie(name, value, days) {
        const expires = new Date();
        expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
    }

    getCookie(name) {
        const nameEQ = name + '=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    // --- Popup UI ---
    createPopup() {
        const overlay = document.createElement('div');
        overlay.className = 'country-selector-overlay';
        overlay.id = 'countrySelector';

        const popup = document.createElement('div');
        popup.className = 'country-selector-popup';
        popup.id = 'country-selector-popup';

        popup.innerHTML = `
            <div class="country-selector-header">
                <h2>Choose Your Region</h2>
            </div>
            <div class="country-selector-options">
                ${Object.entries(this.regions)
                  .map(
                    ([code, region]) => `
                    <button class="country-option" data-region="${code}">
                        <span class="country-flag">${region.flag}</span>
                        <span class="country-name">${region.name.toUpperCase()}</span>
                    </button>
                `
                  )
                  .join('')}
            </div>
            <div class="country-selector-footer">
                <p>We use cookies to remember your choice.</p>
            </div>
        `;

        overlay.appendChild(popup);
        document.body.appendChild(overlay);

        this._listenersAttached = false;
        this.addEventListeners();

        setTimeout(() => {
            overlay.classList.add('show');
        }, 100);
    }

    addEventListeners() {
        if (this._listenersAttached) return;
        this._listenersAttached = true;

        const regionOptions = document.querySelectorAll('.country-option');
        regionOptions.forEach((option) => {
            option.addEventListener(
                'click',
                (e) => {
                    if (this._selecting) return;
                    this._selecting = true;
                    const selectedRegion = e.currentTarget.getAttribute('data-region');
                    this.selectRegion(selectedRegion);
                    setTimeout(() => {
                        this._selecting = false;
                    }, 500);
                },
                { once: true }
            );
        });

        const overlay = document.getElementById('countrySelector');
        overlay.addEventListener('click', (e) => {
            if (e.target === overlay) this.closePopup();
        });

        if (this._onEsc) {
            document.removeEventListener('keydown', this._onEsc);
            this._onEsc = null;
        }
        this._onEsc = (ev) => {
            if (ev.key === 'Escape') {
                const currentOverlay = document.getElementById('countrySelector');
                if (currentOverlay) this.closePopup();
                document.removeEventListener('keydown', this._onEsc);
                this._onEsc = null;
            }
        };
        document.addEventListener('keydown', this._onEsc);
    }

    closePopup() {
        const overlay = document.getElementById('countrySelector');
        if (overlay) {
            overlay.classList.add('hide');
            setTimeout(() => overlay.remove(), 300);
        }
        this._listenersAttached = false;
        if (this._onEsc) {
            try {
                document.removeEventListener('keydown', this._onEsc);
            } catch (e) {}
            this._onEsc = null;
        }
    }

    // --- Inti: 1 fungsi yang ubah currency (display) + market Shopify sekaligus ---
    selectRegion(regionCode) {
        const region = this.regions[regionCode];
        if (!region) return;

        // 1. Simpan preferensi region
        this.setCookie(this.cookieName, regionCode, this.cookieExpireDays);
        try {
            localStorage.setItem('selectedRegion', regionCode);
            // Kunci ini yang dibaca CurrencyConverter untuk nentuin currency yang ditampilkan
            localStorage.setItem('display_currency', region.currency);
        } catch (e) {
            sessionStorage.setItem('selectedRegion', regionCode);
        }

        this.closePopup();

        // 2. Submit FORM /localization asli yang sudah dirender Dawn di header.
        //    Ini jauh lebih reliable daripada fetch manual, karena form asli sudah
        //    include field wajib (_method=put, return_to, form_type, utf8) yang
        //    Shopify butuhkan untuk benar-benar memproses perubahan market.
        //    Submit form = full page navigation, jadi TIDAK perlu reload manual lagi.
        const submitted = this.submitShopifyLocalizationForm(region.shopifyCountry);

        if (!submitted) {
            // Fallback kalau form native tidak ditemukan di DOM (struktur theme custom).
            // Currency display tetap benar (sudah di-set di localStorage di atas),
            // tapi market/bahasa/shipping context Shopify TIDAK akan tersinkron.
            console.warn(
                '[CountrySelector] Form /localization tidak ditemukan di halaman. ' +
                'Market Shopify tidak berubah — cek apakah snippet country-localization/language-localization ter-render di header.'
            );
            window.location.reload();
        }
    }

    // Cari form /localization yang sudah dirender Dawn (biasanya di header),
    // isi input country_code dengan kode negara representative, lalu submit form aslinya.
    submitShopifyLocalizationForm(countryCode) {
        const forms = document.querySelectorAll('localization-form form[action="/localization"]');

        for (const form of forms) {
            const countryInput = form.querySelector('input[name="country_code"]');
            if (countryInput) {
                countryInput.value = countryCode;
                form.submit(); // native submit -> full page reload, Shopify proses market/currency context
                return true;
            }
        }
        return false;
    }

    // Diterapkan untuk returning user (region sudah tersimpan) — TANPA network call/reload.
    applyRegionFeaturesQuiet(regionCode) {
        document.body.setAttribute('data-region', regionCode);
        sessionStorage.setItem('currentRegion', regionCode);
        // display_currency di localStorage sudah ada dari kunjungan sebelumnya;
        // CurrencyConverter otomatis baca ini sendiri saat init, jadi tidak perlu dipanggil manual di sini.
    }

    getCurrentRegion() {
        return this.getCookie(this.cookieName) || sessionStorage.getItem('currentRegion');
    }

    changeRegion() {
        this.setCookie(this.cookieName, '', -1);
        sessionStorage.removeItem('currentRegion');
        try {
            localStorage.removeItem('selectedRegion');
        } catch (e) {}
        this.createPopup();
    }

    // Method untuk dipanggil dari luar (misal tombol "Change region" di footer)
    openPopup() {
        const existingPopup = document.getElementById('countrySelector');
        if (existingPopup) existingPopup.remove();
        this.createPopup();
    }
}

// Safe single initialization
(function initCountrySelectorOnce() {
    if (!window.countrySelector) {
        const init = () => {
            if (!window.countrySelector) {
                window.countrySelector = new CountrySelector();
            }
        };
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init, { once: true });
        } else {
            init();
        }
    }
})();

if (typeof module !== 'undefined' && module.exports) {
    module.exports = CountrySelector;
}